import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IncomeSummary } from '../../models/income.model';
import { User } from '../../models/user.model';
import { UtilityService } from '../utility/utility.service';
import { AuthService } from '../auth/auth.service';
import { API_CONFIG } from '../../config/api.config';

/**
 * Resuelve y guarda el ingreso mensual del usuario actual, usado por la
 * pantalla "Tu ingreso" para splits de grupo "Según ingresos" (TAR-325).
 */
@Injectable({
  providedIn: 'root'
})
export class IncomeService {
  private _utilityService = inject(UtilityService);
  private _authService = inject(AuthService);

  /** GET /users/me/income — ingreso resuelto (manual o promedio) + detalle mensual. */
  getMyIncome(): Observable<IncomeSummary> {
    const url = `${API_CONFIG.baseUrl}${API_CONFIG.modules.user.base}${API_CONFIG.modules.user.endpoints.income}`;
    return this._utilityService.request<IncomeSummary>('GET', url);
  }

  /** Guarda (o cambia) el ingreso manual del usuario. Reutiliza PUT /users/me. */
  setManualIncome(amount: number, currency: string = 'ARS'): Observable<User> {
    return this._authService.updateUserData({
      manual_income_amount: amount,
      manual_income_currency: currency,
    });
  }
}
